import { createElement } from "react";
import { Image as ImageIcon } from "lucide-react";
import {
  ImageTileParamsSchema,
  defaultImageTileParams,
  type ImageTileParams,
} from "@playbookai/widget-schemas";
import type { WidgetBodyProps, WidgetDef } from "../types.js";
import { registerWidget } from "../registry.js";
import { ImageWidget } from "../image/Component.js";

function HostedImageWidget(props: WidgetBodyProps<ImageTileParams>) {
  return createElement(ImageWidget, { ...props, hostedOnly: true });
}

/** SQL definition reusing the legacy Image body; bytes stay in object storage. */
export const imageTileDef: WidgetDef<ImageTileParams> = {
  kind: "imageTile",
  label: "Image",
  modes: ["canvas"],
  singleton: false,
  defaultSize: { w: 320, h: 260 },
  defaultParams: defaultImageTileParams,
  Component: HostedImageWidget,
  storage: "sql",
  schema: ImageTileParamsSchema,
  accent: "neutral",
  icon: ImageIcon,
  subtitle: "Hosted reference image",
  defaultRoster: false,
  category: "multi",
  layout: { col: "full", row: 0, width: 320, height: 236 },
};

registerWidget(imageTileDef);
